module.exports = __webpack_public_path__ + "static/media/117.1458d1cd.jpg";